module.exports = __webpack_public_path__ + "img/m_1.d65f05d3.png";